import { Auth } from '../../redux/slices/auth/state';
import { COOKIES } from '../constants/cookies';

import LOCALSTORAGE from '../constants/localStorage';
import { getCookie } from '../utils/cookies';

const supportedLocale = {
  en: 'en-CA',
  en_CA: 'en-CA',
  'en-CA': 'en-CA',
  fr: 'fr-CA',
  fr_CA: 'fr-CA',
  'fr-CA': 'fr-CA'
};

const renderLocale = (auth?: Auth) => {
  const localStorageLocale = localStorage.getItem(LOCALSTORAGE.USERLOCALE);
  const localAuth = JSON.parse(localStorage.getItem(LOCALSTORAGE.AUTH)!)!;
  const trLocale = getCookie(COOKIES.LOCALE);
  const locale = auth?.user?.lang || localAuth?.user?.lang;
  const navigatorLang =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    supportedLocale.en_CA;

  // If running in omp, try to prioritze locale from local storage
  if (localStorageLocale && supportedLocale[localStorageLocale])
    return supportedLocale[localStorageLocale];

  // If cookies has a locale, use that locale first
  if (trLocale && supportedLocale[trLocale]) return supportedLocale[trLocale];

  // Otherwise, use the language setting in the login response or local storage
  if (locale && supportedLocale[locale]) return supportedLocale[locale];

  // Fallback to browser or just default to English
  return supportedLocale[navigatorLang] || supportedLocale.en_CA;
};

export default renderLocale;
